module.exports = __webpack_public_path__ + "img/021-boat.b28cb386.svg";